import { render, staticRenderFns } from "./index--device.vue?vue&type=template&id=e28f05f2&scoped=true&"
import script from "./index--device.vue?vue&type=script&lang=js&"
export * from "./index--device.vue?vue&type=script&lang=js&"
import style0 from "./index--device.vue?vue&type=style&index=0&id=e28f05f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28f05f2",
  null
  
)

export default component.exports